import React, { useState, Fragment, useEffect } from 'react';
import {
  Row,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  Button,
  UncontrolledDropdown,
  FormGroup,
  Label,
  TabPane,
  Card,
  CardBody,
  Input,
  Badge,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  gAPI_Internal_Property_By_Id,
  gAPI_Response_Amadeus,
  gAPI_Response_Availability,
} from '../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import classnames from 'classnames';
export function AvailabilityAndRates({ amadues, shr, propertyId }) {
  const [startDate, setStartDate] = useState(moment().add(2, 'days'));
  const [spinnerStatus, setSpinnerStatus] = useState('default');
  const [endDate, setEndDate] = useState(moment().add(5, 'days'));
  const [adultCount, setAdultCount] = useState(1);
  const [roomsCount, setRoomCount] = useState(1);
  const [childrenCount, setChildrenCount] = useState(0);
  const [rooms, setRooms] = useState([]);
  const [discountCode, setDiscountCode] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const [error, setError] = useState('');
  const [dropDown, setDropDown] = useState('');
  const [propertyData, setPropertyData] = useState();
  const toggle = () => {
    setIsVisible(!isVisible);
  };

  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
    }).then((res) => {
      setPropertyData(res.data);
    });
    handleSubmit();
  }, [getGroupID()]);

  const handleDropDown = () => {
    if (dropDown === '') setDropDown('show');
    else setDropDown('');
  };

  const handleSearchfilterDate = (date) => {
    setStartDate(date);
  };
  const handleSearchfilterEndDate = (date) => {
    setEndDate(date);
  };

  const handleSubmit = () => {
    setDropDown('');
    if (shr !== undefined) {
      if (startDate !== undefined && endDate !== undefined) {
        setSpinnerStatus('processing');
        setRooms([]);
        AxiosAPI({
          method: 'get',
          url: `${gAPI_Response_Availability}/${shr.id
            }?group_id=${getGroupID()}&adults=${adultCount}&rooms=${roomsCount}&dateIn=${moment(
              startDate
            ).format('YYYY-MM-DD')}&dateOut=${moment(endDate).format(
              'YYYY-MM-DD'
            )}&children=${childrenCount}&ratePlanCode=&channel=SHRCRS`,
        }).then((res) => {
          if (res.data.dates !== undefined && res.data.dates.length > 0) {
            setSpinnerStatus('success');
            setRooms(res.data.dates);
          } else {
            setError('Something went wrong.');
            setSpinnerStatus('success');
          }
        });
      }
    } else {
      if (startDate !== undefined && endDate !== undefined) {
        setSpinnerStatus('processing');
        setRooms([]);
        AxiosAPI({
          method: 'get',
          url: `${gAPI_Response_Amadeus}/${amadues.id
            }/availablity?group_id=${getGroupID()}&adults=${adultCount}&rooms=${roomsCount}&dateIn=${moment(
              startDate
            ).format('YYYY-MM-DD')}&dateOut=${moment(endDate).format(
              'YYYY-MM-DD'
            )}&children=${childrenCount}&promoCode=${discountCode}`,
        }).then((res) => {
          if (
            res.data.roomStays !== undefined &&
            res.data.roomStays.length > 0
          ) {
            let roomTypes = res.data.roomStays[0].allRoomTypes;
            let ratePlans = res.data.roomStays[0].ratePlans;
            if (roomTypes.length > 0) {
              let rooms = [];
              roomTypes.map((m) => {
                let obj = {};
                obj.available = m.available;
                obj.roomImage =
                  process.env.REACT_APP_TRAVELCLICK_IMAGE_LINK +
                  m.mainImage?.source;
                obj.roomTypeName = m.roomTypeName;
                obj.roomTypeCode = m.roomTypeCode;
                if (m.averageRates !== undefined && m.averageRates.length > 0) {
                  let rates = [];
                  m.averageRates
                    .filter((f) => f.available === true)
                    .map((r) => {
                      let ratePlanName = '';
                      let ratePlanCode = '';
                      if (ratePlans.length > 0) {
                        ratePlanName = ratePlans.filter(
                          (f) => f.ratePlanCode === r.ratePlanCode
                        )[0].ratePlanName;
                        ratePlanCode = ratePlans.filter(
                          (f) => f.ratePlanCode === r.ratePlanCode
                        )[0].ratePlanCode;
                      }
                      rates.push({
                        discount: Math.round(r.discount),
                        currencyCode: res.data.currencyCode,
                        ratePlanName: ratePlanName,
                        ratePlanCode: ratePlanCode,
                        price: Math.round(r.price, 2),
                      });
                    });
                  obj.selectedRate = rates[0];
                  obj.rates = rates;
                  rooms.push(obj);
                }
              });
              setSpinnerStatus('success');
              setRooms(rooms);
            }
          } else {
            setError('Something went wrong.');
            setSpinnerStatus('success');
          }
        });
      }
    }
  };

  const handleRatePlan = (roomTypeCode, ratePlanCode) => {
    let lst = [...rooms];
    lst.map((f) => {
      if (f.roomTypeCode === roomTypeCode) {
        f.rates.map((r) => {
          if (r.ratePlanCode === ratePlanCode) f.selectedRate = r;
        });
      }
    });
    setRooms(lst);
  };
  return (
    <Fragment>
      <Card className="card-box">
        <CardBody>
          <div
            className="cardHeight"
            style={{ overflowX: 'hidden', overflowY: 'hidden' }}
          >
            <div className="col-md-12 p-2" style={{ background: 'lightgrey' }}>
              <Fragment>
                <div className="d-flex" style={{ height: '42px' }}>
                  <FormGroup style={{ width: '20%' }}>
                    <DatePicker
                      style={{ borderRadius: "10px" }}
                      selected={startDate ? new Date(startDate) : null} // ensure Date object
                      onChange={handleSearchfilterDate}
                      placeholderText="Start Date"
                      dateFormat="dd/MM/yyyy"   // ✅ correct format
                    />
                  </FormGroup>
                  <FormGroup style={{ width: '20%' }} className="ml-2">
                    <DatePicker
                      style={{ borderRadius: "10px" }}
                      selected={endDate ? new Date(endDate) : null} // ✅ always Date object
                      onChange={handleSearchfilterEndDate}
                      placeholderText="End Date"
                      dateFormat="dd/MM/yyyy"   // ✅ correct format
                    />
                  </FormGroup>
                  <FormGroup style={{ width: '40%' }} className="ml-2">
                    <UncontrolledDropdown>
                      <DropdownToggle
                        caret
                        color="outline-white"
                        onClick={handleDropDown}
                        style={{
                          width: '100%',
                          borderRadius: '0px',
                          height: '42px',
                          background: 'white',
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          strokeWidth="1"
                          stroke="currentColor"
                          style={{ width: '20px', height: '20px' }}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
                          />
                        </svg>
                        {roomsCount} Rooms {adultCount} Adults {childrenCount}{' '}
                        Childrens
                      </DropdownToggle>
                    </UncontrolledDropdown>
                    {dropDown === 'show' && (
                      <div
                        style={{
                          position: 'absolute',
                          padding: '10px',
                          background: 'white',
                          zIndex: '999999',
                        }}
                      >
                        <Row className="mb-2">
                          <Colxx md="6">Adults</Colxx>
                          <Colxx md="6">
                            <Input className='input_sty'
                              type="number"
                              value={adultCount}
                              onChange={(e) => setAdultCount(e.target.value)}
                            ></Input>
                          </Colxx>
                        </Row>
                        <Row className="mb-2">
                          <Colxx md="6">Rooms</Colxx>
                          <Colxx md="6">
                            <Input className='input_sty'
                              type="number"
                              value={roomsCount}
                              onChange={(e) => setRoomCount(e.target.value)}
                            ></Input>
                          </Colxx>
                        </Row>
                        <Row className="mb-2">
                          <Colxx md="6">Childrens</Colxx>
                          <Colxx md="6">
                            <Input className='input_sty'
                              type="number"
                              value={childrenCount}
                              onChange={(e) => setChildrenCount(e.target.value)}
                            ></Input>
                          </Colxx>
                        </Row>
                        <Row>
                          <Colxx md="6">Promo Code</Colxx>
                          <Colxx md="6">
                            <Input className='input_sty'
                              type="text"
                              value={discountCode}
                              onChange={(e) => setDiscountCode(e.target.value)}
                            ></Input>
                          </Colxx>
                        </Row>
                      </div>
                    )}
                  </FormGroup>
                  <Button
                    color="primary"
                    style={{
                      borderRadius: '0px',
                      height: '42px',
                      width: '20%',
                    }}
                    outline
                    size="xs"
                    onClick={handleSubmit}
                    className={`btn-multiple-state  ml-2 ${classnames({
                      'show-spinner': spinnerStatus === 'processing',
                      'show-success': spinnerStatus === 'success',
                      'show-fail': spinnerStatus === 'fail',
                    })}`}
                  >
                    <span className="spinner d-inline-block">
                      <span className="bounce1" />
                      <span className="bounce2" />
                      <span className="bounce3" />
                    </span>
                    <span className="icon success">
                      <i className="simple-icon-check" />
                    </span>
                    <span className="icon fail">
                      <i className="simple-icon-exclamation" />
                    </span>
                    <span className="label">Submit</span>
                  </Button>
                </div>
              </Fragment>
            </div>
            <Row className="col-md-12 text-center"></Row>
            <PerfectScrollbar
              style={{ paddingBottom: '8rem' }}
              option={{ suppressScrollX: true, wheelPropagation: false }}
            >
              {rooms.map((m, index) => {
                return (
                  <Card className="room-shadow">
                    <div key={index} className="row">
                      <div className="col-md-5">
                        <img src={m.roomImage} className="room_image"></img>
                      </div>
                      <div className="col-md-7" style={{ padding: '20px' }}>
                        <Badge
                          key={index}
                          className="position-absolute badge-position"
                          color={m.available === true ? 'sky-blue ' : 'gray'}
                          pill
                        >
                          {m.available === true ? 'Available' : 'Not Available'}
                        </Badge>
                        <div className="room-name">
                          <h5 className="mb-2">{m.roomTypeName}</h5>
                        </div>
                        <div className="text-right font-weight-medium d-none d-sm-block absolute-right mb-2">
                          <UncontrolledDropdown>
                            <DropdownToggle
                              caret
                              color="outline-white"
                              className="absolute-dropdown"
                            >
                              {m.selectedRate.ratePlanName} (
                              {propertyData?.currency}){' '}
                              <span>
                                <b>{m.selectedRate.price}</b>
                              </span>
                              <br />
                              Discount ({propertyData?.currency}):{' '}
                              <span>
                                <b>{m.selectedRate.discount}</b>
                              </span>
                            </DropdownToggle>
                            {m.rates !== undefined &&
                              m.rates.length > 0 &&
                              m.rates.filter(
                                (f) =>
                                  f.ratePlanCode !== m.selectedRate.ratePlanCode
                              ).length > 0 && (
                                <DropdownMenu caret>
                                  {m.rates !== undefined &&
                                    m.rates.length > 0 &&
                                    m.rates
                                      .filter(
                                        (f) =>
                                          f.ratePlanCode !==
                                          m.selectedRate.ratePlanCode
                                      )
                                      .map((r) => (
                                        <DropdownItem
                                          onClick={() =>
                                            handleRatePlan(
                                              m.roomTypeCode,
                                              r.ratePlanCode
                                            )
                                          }
                                        >
                                          <b>{r.ratePlanName}</b>
                                        </DropdownItem>
                                      ))}
                                </DropdownMenu>
                              )}
                          </UncontrolledDropdown>
                        </div>
                      </div>
                    </div>
                  </Card>
                );
              })}
            </PerfectScrollbar>
          </div>
        </CardBody>
      </Card>
      <Modal isOpen={isVisible} toggle={toggle}>
        <ModalHeader toggle={toggle}>Input Error</ModalHeader>
        <ModalBody>
          <div className="m-2">{error}</div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}
